import { LoggingService } from '@instinet-analytics/core-lib';
import { buildLogger, Logger } from '@instinet-analytics/core-lib';
import { NotificationService } from 'notification/NotificationService';
import { buildFromWebsocketErrorCode } from 'communication/streaming/StreamingErrorText';

export interface StreamStatusMessageAlertManagerOptions {
    loggingService: LoggingService;
    notificationService: NotificationService;
}

const THROTTLE = 60000; // 1 min

/*
 * Responsible for alerting stream status messages to the user, throttling as necessary (for each message code)
 */
export class StreamStatusMessageAlertManager {
    private logger: Logger;
    private notificationService: NotificationService;

    private throttledStatusCodes: { [code: number]: number } = {};

    public constructor(options: StreamStatusMessageAlertManagerOptions) {
        this.logger = buildLogger(
            'StreamStatusMessageAlertManager',
            options.loggingService
        );
        this.notificationService = options.notificationService;
    }

    public alert(code: number) {
        if (this.throttled(code)) {
            return;
        }

        this.throttledStatusCodes[code] = new Date().getTime() + THROTTLE;

        const message = buildFromWebsocketErrorCode(code);

        this.notificationService.showWarning(message.title);
    }

    private throttled(code: number) {
        return (
            this.throttledStatusCodes[code] &&
            this.throttledStatusCodes[code] > new Date().getTime()
        );
    }
}
